import * as React from 'react';
import { useSelector } from 'react-redux';
import { EBetPositionStatus } from '../../../../redux/reducers';
import {
  selectBetPageFullConcurrency,
  selectBetPositionStatus,
  selectBetServiceConcurrency,
} from '../../../../selectors/betPosition';
import { selectActiveServiceId } from '../../../../selectors/publishTerms';
import { formatServiceName } from '../../../../utils/publishTerms';
import { BetPositionErrorContainer } from '../BetPositionError';
import { BetPosition } from './BetPosition';

export const BetPositionContainer = () => {
  const pagePosition = useSelector(selectBetPageFullConcurrency);
  const offerPosition = useSelector(selectBetServiceConcurrency);
  const serviceId = useSelector(selectActiveServiceId);
  const status = useSelector(selectBetPositionStatus);

  const serviceName = serviceId ? formatServiceName(offerPosition || 0, serviceId) : '';

  const isSuccess = status === EBetPositionStatus.success;
  const isLoading = status === EBetPositionStatus.pending;
  const isDataEmpty = pagePosition === null && offerPosition === null;

  if (isSuccess && isDataEmpty) {
    return null;
  }

  if (status === EBetPositionStatus.fail) {
    return <BetPositionErrorContainer />;
  }

  return (
    <BetPosition
      isLoading={isLoading}
      isDataEmpty={isDataEmpty}
      pagePosition={pagePosition}
      offerPosition={offerPosition}
      serviceName={serviceName}
    />
  );
};
